import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CheckoutAdapter } from '@spartacus/checkout/base/core';
import { OccCheckoutAdapter } from './occ-checkout.adapter';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: CheckoutAdapter,
      useClass: OccCheckoutAdapter,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class ExtendCheckoutOccModule {}
